import { FaMedal, FaLightbulb, FaWallet, FaHeadphones } from "react-icons/fa";

const featuresData = [
    {
        id: 1,
        icon: <FaMedal />,
        title: "Quality Services",
        info: "All our services are high quality, as we offer our partners the best from the best.",
    },
    {
        id: 2,
        icon: <FaLightbulb />,
        title: "Valuable Ideas",
        info: "We offer valuable ideas that can help you streamline processes and boost profits.",
    },
    {
        id: 3,
        icon: <FaWallet />,
        title: "Budget Friendly",
        info: "We provide low-cost consulting options to accelerate the growth of your business.",
    },
    {
        id: 4,
        icon: <FaHeadphones />,
        title: "Support 24/7",
        info: "We offer on-demand support options including 24/7 technical & remote support.",
    },
];

export default featuresData;